import { Question, QuestionAnswer } from "@/types/questions";

declare global {
  interface Window {
    digitalData: any;
  }
}

const initializeDigitalData = (): void => {
  if (typeof window !== "undefined") {
    if (!window.digitalData) {
      window.digitalData = {};
    }

    if (!window.digitalData.page) {
      window.digitalData.page = {};
    }

    if (!window.digitalData.page.learningCompass) {
      window.digitalData.page.learningCompass = {};
    }
  }
};

export const trackStart = (): void => {
  try {
    initializeDigitalData();
    window.digitalData.page.learningCompass["status"] = "started";
  } catch (e) {
    console.error(e);
  }
};

export const trackCompleteStep = (
  activeStep: number,
  questions: Question[],
  answer: QuestionAnswer | QuestionAnswer[]
): void => {
  try {
    initializeDigitalData();

    const currentQuestion = questions.find((q) => q.step === activeStep);

    if (currentQuestion) {
      window.digitalData.page.learningCompass[`step_${currentQuestion.step}`] =
        {
          step: currentQuestion.step,
          question: currentQuestion.question,
          answers: Array.isArray(answer)
            ? answer.map((a) => a.text)
            : [answer.text],
          event: "completed_step",
        };
    }
  } catch (e) {
    console.error(e);
  }
};

export const trackComplete = (): void => {
  try {
    initializeDigitalData();
    window.digitalData.page.learningCompass["status"] = "completed";
  } catch (e) {
    console.error(e);
  }
};

export const trackLinkClick = (label: string, url: string): void => {
  try {
    initializeDigitalData();

    if (!window.digitalData.page.learningCompass.events) {
      window.digitalData.page.learningCompass.events = [];
    }

    window.digitalData.page.learningCompass.events.push({
      eventName: "link_clicked",
      label,
      url,
    });
  } catch (e) {
    console.error(e);
  }
};
